import React, { Component } from 'react'
import './styles.css'
import PropTypes from 'prop-types'
class TableData extends Component {
  render () {
    return (
      <div className={'TableData ' + (this.props.className !== undefined ? this.props.className : '')}
           onClick={this.props.onClick}>
        {this.props.children}
      </div>
    )
  }
}
TableData.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
  onClick: PropTypes.func
}
export default TableData
